import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{staticClass:"reloadButton",attrs:{"disabled":_vm.disabled,"fab":"","absolute":"","right":"","color":"primary"}},[(_vm.loading)?_c(VIcon,{staticClass:"mdi-spin",attrs:{"color":"white"}},[_vm._v("mdi-loading")]):_c(VIcon,[_vm._v("mdi-reload")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }